module.exports = __webpack_public_path__ + "img/notification.4456c751.svg";